import {
  deleteRequest,
  getRequest,
  postRequest
} from "@/views/academy/api/apiRequests";
import { CreateRegistrationApiEndpoints } from "@/views/academy/createregistration/CreateRegistrationApiEndpoints";
import { prepareQueryParams } from "@/helpers/prepareQueryParams";
import { i18n } from "@/plugins/i18n";

const state = () => ({
  registrationUuid: null
});

const getters = {
  registrationUuid: (state: { registrationUuid: string }) =>
    state.registrationUuid
};

const mutations = {
  setRegistrationUuid: (
    state: { registrationUuid: any },
    payload: { registrationUuid: any }
  ) => {
    state.registrationUuid = payload.registrationUuid;
  }
};

const actions = {
  createRegistration: async (
    context: any,
    payload: {
      registrationType: string;
      orgUnitId: string;
      callback: Function;
    }
  ) => {
    const { registrationType, orgUnitId, callback } = payload;
    try {
      const res: any = await postRequest(
        CreateRegistrationApiEndpoints.CREATE_REGISTRATION,
        {
          registrationType,
          orgUnitId
        }
      );
      if (res.status === "success") {
        context.commit("setRegistrationUuid", {
          registrationUuid: res.data.id
        });
        callback && callback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  fetchRegistration: async (
    context: any,
    payload: {
      registrationStatus: string;
      orgUnitId: string;
      filter: string;
      tags: any;
      callback: Function;
      isAllTeams: boolean;
    }
  ) => {
    const {
      registrationStatus,
      orgUnitId,
      filter,
      tags,
      callback,
      isAllTeams
    } = payload;
    try {
      const query = prepareQueryParams({
        registrationStatus,
        filter,
        tags,
        pageSize: 50,
        isAllTeams
      });
      const res: any = await getRequest(
        `${CreateRegistrationApiEndpoints.REGISTRATION_LISTING}/${orgUnitId}${query}`
      );
      if (res.status === "success") {
        callback && callback(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  },

  deleteRegistration: async (
    context: any,
    payload: {
      registrationId: string;
      callback: Function;
    }
  ) => {
    const { registrationId, callback } = payload;
    try {
      const res: any = await deleteRequest(
        `${CreateRegistrationApiEndpoints.DELETE_REGISTRATION}/${registrationId}`
      );
      if (res.status === "success") {
        await context.dispatch(
          "snackbar/SHOW_SNACKBAR",
          { text: i18n.tc("snackbar_message.removed_successfully") },
          {
            root: true
          }
        );
        callback && callback();
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
